import { useQuery } from '@tanstack/react-query';
import { getSettingsAccount, type SettingsAccountResponse } from '../../../api/settingsAccount';
import { ReactQueryKey } from '../../../constants/ReactQueryKeys';

interface UseSettingsAccountProps {
  accountId: number;
  isSystemAdmin: boolean;
  enabled?: boolean;
}

const useSettingsAccount = ({ accountId, isSystemAdmin, enabled = true }: UseSettingsAccountProps) => {
  return useQuery<SettingsAccountResponse, unknown>({
    queryKey: [ReactQueryKey.GET_CLIENT_ACCOUNT, 'settings-account', accountId, isSystemAdmin],
    queryFn: () => getSettingsAccount({ accountId, isSystemAdmin }),
    enabled: enabled && Number.isInteger(accountId) && accountId > 0,
  });
};

export default useSettingsAccount;
